import { Link } from 'react-router-dom';

const categories = [
  { label: '电影', value: '电影', icon: 'ri-film-line', desc: '荡气回肠的银幕经典' },
  { label: '电视剧', value: '电视剧', icon: 'ri-tv-2-line', desc: '抽丝剥茧的剧集叙事' },
  { label: '纪录片', value: '纪录片', icon: 'ri-movie-2-line', desc: '深海探秘与历史真相' },
];

export default function CategoryQuickLinks() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6 md:mb-8">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">影视快速分类</h2>
        <Link to="/category" className="text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap">
          查看全部 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.value}
            to={`/category?type=${encodeURIComponent(cat.value)}`}
            className="group flex items-center gap-4 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:shadow-none transition-colors cursor-pointer"
          >
            <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors shrink-0">
              <i className={`${cat.icon} text-2xl`}></i>
            </div>
            <div>
              <h3 className="font-semibold text-foreground-900 mb-1">{cat.label}</h3>
              <p className="text-xs text-foreground-500">{cat.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}